/*
 * @Author: 李明明
 * @Date: 2022-07-28 09:33:50
 * @LastEditTime: 2024-06-03 11:11:23
 * @LastEditors: 李明明
 * @Description:
 * @FilePath: /ykt-micro-main/src/router/index.js
 * 代码版权方：'政府采购信息网'
 */
import { createRouter, createWebHashHistory } from "vue-router";
import CourseDetail from "../views/courseDetail/index.vue";
import Redirect from "../views/redirect/index.vue";
import transfer from "../views/transfer/course_detail";

const routes = [
  {
    path: "/",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/home/index.vue"),
    meta: {
      title: "首页",
    },
  },
  {
    path: "/home_list",
    name: "HomList",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/home/home_list.vue"),
    meta: {
      title: "研修班列表",
    },
  },
  {
    path: "/shanxi_list",
    name: "ShanxiList",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/home/shanxi_list.vue"),
    meta: {
      title: "研修班列表",
    },
  },
  {
    path: "/browser-tip",
    name: "BrowserTip",
    component: () =>
      import(/* webpackChunkName: "browser-tip" */ "../views/browser-tip/index.vue"),
    meta: {
      title: "浏览器提示",
    },
  },
  {
    path: "/courseDetail",
    name: "CourseDetail",
    component: CourseDetail,
    meta: {
      title: "课程详情",
    },
  },
  /**
   * 课程详情页的中转页（短链接）
   * w 为 路由前置路径，:id 为 courseId
   */
  {
    path: "/w/:id",
    name: "Transfer",
    component: transfer,
  },
  /* 重定向 */
  {
    path: "/course_detail_inline",
    component: Redirect,
    redirect: "/courseDetail",
    meta: {
      title: "课程详情",
    },
  },
  {
    path: "/course_detail",
    name: "Info",
    component: CourseDetail,
    redirect: "/course/info",
    meta: {
      title: "课程详情",
    },
  },
  {
    path: "/new_home",
    name: "Info",
    component: CourseDetail,
    redirect: "/",
    meta: {
      title: "首页",
    },
  },
  /* 重定向结束 */
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
